import { createSelector } from 'reselect';

const getJobTableDefinitions = state => state.referenceData.jobTableDefinitions;//(state && state.referenceData && state.referenceData.jobTableDefinitions) ?state.referenceData.jobTableDefinitions:null;
const getUserColumnVisibilities = state =>    state.referenceData.userColumnVisibilities;//(state && state.referenceData && state.referenceData.userColumnVisibilities) ?state.referenceData.userColumnVisibilities:null;
//const getCurrentWorkflowState = (state, props) => props?props.state?props.state:props.param?props.params:null:null;
const getCurrentWorkflowState = (state, workflowState) => workflowState;

const getVisibleColumnsForWorkflow = createSelector(
 [getUserColumnVisibilities, getCurrentWorkflowState],
  (columnVisibilities, currentStateParam) => {
    const currentState =  currentStateParam?currentStateParam.replace('-', ' '):'assigned' ;
    const setting = columnVisibilities.find(({ state }) => state.toLowerCase() === currentState.toLowerCase());
    return (setting && setting.visibleColumns) || [];
  }
);
/*
const getVisibleColumnsForWorkflow = createSelector(
  [getUserColumnVisibilities, getCurrentWorkflowState],
  (columnVisibilities, currentState) => {
     // currentState = 'new';
  // var newDef 
  /* if( columnVisibilities!=null){
    newDef = columnVisibilities;
   }*/
   //const setting = columnVisibilities.find(({ state }) => currentState?state === currentState.replace('-',' '):'new')
   // return (setting && setting.visibleColumns) || [];
    //return []
 //}
//);
/*
const getJobTableDefinitions =  (state)=>{
  console.log('jtdState.reference',state.referenceData)
  if(state.referenceData!=null)
  return state.referenceData
} 
/*
export const getDefinitionForWorkflow=(state,ownProps)=>{
  console.log('jtdState',state)
  console.log('jtdownProps',ownProps)
  return []
};*/
/*
export const getDefinitionForWorkflow = createSelector(
  [getJobTableDefinitions, getVisibleColumnsForWorkflow],
  (jobTableDefinitions, visibleColumns) => {
    return  []/*jobTableDefinitions.map((column) => ({
      ...column,
      visible: visibleColumns.includes(column.key),
    }));*/
 //// }
//);

export const getDefinitionForWorkflow = createSelector(
  [getJobTableDefinitions, getVisibleColumnsForWorkflow],
  (jobTableDefinitions, visibleColumns) => {
    return jobTableDefinitions.map(column => ({
      ...column,
      visible: visibleColumns.includes(column.key)
    }));
  }
);
